export const payment_types = [
  { label: 'WebPay Crédito', value: 3 },
  { label: 'WebPay Débito', value: 2 },
  { label: 'Pago Presencial', value: 1 },
]